import { useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../lib/api.js';

export function useSync() {
  const qc = useQueryClient();
  return useMutation({
    // Le backend (schemas/sync.schemas.js) attend { mode }, pas { full } — avec
    // additionalProperties: false + removeAdditional, `full` était supprimé
    // silencieusement et retombait toujours sur mode='incremental' (bug 3).
    //
    // Lot 2b-2 : POST /sync (orchestrateur multi-providers) au lieu de
    // POST /sync/qonto — le bouton doit marcher pour une entité sans Qonto
    // (cas VRESCO, Revolut-only). La réponse est un objet par provider
    // ({ qonto, wise, revolut, ... } selon présence), consommé tel quel par
    // SettingsPage pour l'affichage par provider.
    mutationFn: ({ full = false } = {}) =>
      api.post('/sync', { mode: full ? 'full' : 'incremental' }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['transactions'] });
      qc.invalidateQueries({ queryKey: ['categories'] });
      qc.invalidateQueries({ queryKey: ['balance'] });
      qc.invalidateQueries({ queryKey: ['recurrences'] });
      // Wise/Revolut peuvent créer de nouveaux bank_accounts pendant le sync.
      qc.invalidateQueries({ queryKey: ['bank-accounts'] });
    },
  });
}
